import { useEffect, useCallback, useRef } from "react";
import { Sidebar as PrimeReactSidebar } from "primereact/sidebar";

// Sidebars abiertos, en el orden en que se abrieron: ESC cierra solo el último
// (el que está encima). Sin esto, con un sidebar abierto desde otro, ESC
// cerraba el que se hubiera registrado primero.
const abiertos = [];

// Wrapper de Sidebar que corrige el comportamiento de ESC:
// - Si hay un overlay abierto (dropdown, datepicker, multiselect), el primer
//   ESC cierra el overlay y el segundo cierra el sidebar.
// - Con varios sidebars abiertos, cierra de a uno, del último al primero.
export default function Sidebar({ visible, onHide, children, ...props }) {
  const id = useRef(Symbol("sidebar")).current;

  // Entra a la pila al abrirse y sale al cerrarse (o al desmontarse)
  useEffect(() => {
    if (!visible) return;
    abiertos.push(id);
    return () => {
      const indice = abiertos.lastIndexOf(id);
      if (indice !== -1) abiertos.splice(indice, 1);
    };
  }, [visible, id]);

  const handleEsc = useCallback(
    (e) => {
      if (e.key !== "Escape" || !visible) return;
      // Solo el de más arriba
      if (abiertos[abiertos.length - 1] !== id) return;

      const overlayOpen = document.querySelector(
        ".p-dropdown-panel, .p-datepicker, .p-multiselect-panel, .p-cascadeselect-panel"
      );

      if (!overlayOpen) {
        onHide(e);
      }
    },
    [visible, onHide, id]
  );

  useEffect(() => {
    if (!visible) return;
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [visible, handleEsc]);

  return (
    <PrimeReactSidebar
      visible={visible}
      onHide={onHide}
      closeOnEscape={false}
      {...props}
    >
      {children}
    </PrimeReactSidebar>
  );
}
